import React, {useState,useEffect } from "react";
import { Link,useSearchParams } from 'react-router-dom'
import {getUserSkills,httpSelectUserSkill,httpCreateUserGroup,httpSelectUserIdBySkill} from "../../Employee/Skills/api/calls"

const UserGroupSkill = ({ group_id,userSkillParentCallback,btn_action,group_name}) => {

  const [skill,setSkill] = useState(null);

  const [selected,setSelectedSkill] = useState([]);
  const [isChecked, setIsChecked] = useState([])
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get('id')
    

  useEffect(() => {
    getUserSkills(group_id).then((data) =>{
      if(data) setSkill(data.data);
   });
   if(btn_action === 'add'){
    setSelectedSkill('');
   }else if(btn_action === 'edit'){
    httpSelectUserIdBySkill(id).then((data2) =>{
   
      if(data2) setSelectedSkill(data2.data);
     })
    
   }else{
    httpSelectUserSkill().then((data2) =>{

      if(data2) setSelectedSkill(data2.data);
     })
   }
  
  }, [group_id,group_name]);
  const handleSkillChange = (event) =>{
    const {value,checked} = event.target

    if(checked){

      
      if(btn_action === 'add'){
        setIsChecked(current => [...current,  +value]);
        setSelectedSkill(current => [...current,  +value]);

        onTargetSkillSetData([...selected,+value])
      }else if(btn_action === 'edit'){
        setIsChecked(current => [...current,  +value]);
        setSelectedSkill(current => [...current,  +value]);
        onTargetSkillSetData([...isChecked,+value])
      }else{
        setIsChecked(current => [...current,  +value]);
        setSelectedSkill(current => [...current,  +value]);
      }
    }else{
      
      if(btn_action === 'add'){
        let newSelectedValue=selected.filter((el) => el!==+value);
        setIsChecked(newSelectedValue)
        setSelectedSkill(newSelectedValue)
        onTargetSkillSetData(newSelectedValue)
      }else{
        let newSelected=selected.filter((el) => el!==+value);

      setIsChecked(newSelected)
      setSelectedSkill(newSelected)
      }
    }
   
  }
    const onTargetSkillSetData = (data) =>{
  
      userSkillParentCallback(data)
    }
  
    

  const onsubmitHandler = (event) => {
    event.preventDefault();

      httpCreateUserGroup(isChecked).then((res) =>{
        if (res.status) {
          return alert(res.msg);
        } else {
          return alert(res.msg);
        }
      });
          
          // });
    
  };
  //console.table(selected.filter(p => p.skill_id.includes(26)))
  //console.table(selected.filter(p => p.skill_id.includes(26)))
  

  return (
    <>
    <ul className="timeline_wrp">
        
        <li>
          <div className="timeline_icon1"></div>
          <div className="timeline_icon"></div>
          <div className="timeline_text">
            <div className="form-blk">
              <div className="form-label formlabel_ttl">{group_name}</div>
              <div className="row">
              {skill &&
                skill.map((item, i) => {
                  return (
                <div className="col-md-4" key={i}>
                  <div className="form-check formcheck1">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={selected.includes(item.skill_id)}
                      value={item.skill_id}
                      onChange={handleSkillChange}
                    />
                    <label className="form-check-label" htmlFor="php">
                      {item.skill_name}
                    </label>
                  </div>
                </div>
                  )})}
              </div>
              
            </div>
           
          </div>
          
        </li>
       
      </ul>
      {btn_action === 'view' ?
      <div className="text-end">
      
      <button className="btn_5" onClick={onsubmitHandler} >Save</button>
      <Link to='/employeelist' className="btn_6 ml10">Cancel</Link>
      </div>
      :''}
    </>
  );
}
export default UserGroupSkill;